import { EmailLink } from '@/components/blocks/links/EmailLink';
import { COMPANY_INFO_EMAIL, COMPANY_NUMBER } from '@/constants/company-data';
import { useAuth } from '@/hooks/useAuth';

import { FooterLegal } from './FooterLegal';
import { FooterNav } from './FooterNav';

const accountCenterUrl = process.env.NEXT_PUBLIC_ACCOUNT_CENTER_URL;

export const FooterDesktop = () => {
  const { isAuthenticated } = useAuth();
  const softwareSupportHref = isAuthenticated
    ? 'https://marshallreddick.atlassian.net/servicedesk/customer/portals'
    : `${accountCenterUrl}/login`;

  return (
    <footer className="relative z-20 bg-footer-bg border-t-[3px] border-footer-border pt-2.5 pr-4 text-center text-footer text-sm">
      <div className="mx-auto w-full max-w-sm sm:max-w-xl md:max-w-3xl lg:max-w-5xl xl:max-w-300 px-6 pb-5">
        <div className="py-0.75 text-footer text-base">
          {COMPANY_NUMBER} &bull;{' '}
          <EmailLink
            email={COMPANY_INFO_EMAIL}
            className="text-footer hover:text-footer-text-hover underline"
          />
        </div>
        <FooterNav softwareSupportHref={softwareSupportHref} />
        <FooterLegal />
      </div>
    </footer>
  );
};
